import { UserOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { BUTTON_KEYS, BUTTON_TYPE } from "@/constants/Button";

const UserAccessButton = ({
  disabled,
  loading,
  type = BUTTON_TYPE.DEFAULT,
  onUserAccessSelect,
  buttonProps = {},
}) => {
  const { t } = useTranslation();

  return (
    <Button
      data-testid="userAccessButton"
      disabled={disabled}
      icon={<UserOutlined />}
      key={BUTTON_KEYS.DELETE}
      loading={loading}
      role="button"
      type={type}
      onClick={onUserAccessSelect}
      {...buttonProps}
    >
      {t("global:manageUserAccess")}
    </Button>
  );
};

export default UserAccessButton;
